module.exports = __webpack_public_path__ + "static/media/potentiometer.d71a0e28.svg";